import { __extends } from "tslib";
import * as ltjsUtil from '../../ltjsUtil';
import Position from '../popover/Position';
import Popover from '../popover/Popover';
var POSITIONS = [Position.TOP, Position.LEFT, Position.BOTTOM, Position.RIGHT];
var MAX_DATA_VALUES = 60;
function _createString(resource, args) {
    for (var i = 0, len = args.length; i < len; ++i) {
        resource = resource.replace("{".concat(i, "}"), String(args[i]));
    }
    return resource;
}
function _setCSSStyleVariable(container, variableName, value) {
    if (value === null || value === undefined) {
        container === null || container === void 0 ? void 0 : container.style.removeProperty(variableName);
    }
    else {
        container === null || container === void 0 ? void 0 : container.style.setProperty(variableName, value);
    }
}
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super.call(this) || this;
        _this._tooltipData = undefined;
        _this._naiveLength = Number.MAX_VALUE;
        _this._tooltipValues = null;
        _this._positions = POSITIONS;
        _this._classNames = _this._classNames.concat('sasTooltip');
        _this._tipColonString = ltjsUtil.getLocalizedString('sas_commons', 'tooltip.colon.fmt.txt');
        _this._tipNumberDisplayedString = ltjsUtil.getLocalizedString('sas_commons', 'tooltip.numberDisplayed.fmt.txt');
        _this.setNamespace('sas.ltjs.commons.ui.tooltip.Tooltip');
        return _this;
    }
    Tooltip.prototype._resetContent = function (target, constraint) {
        target = target; // shut tsc up
        var tablesContainer = this.getDomRef('.sasTableContainer');
        if (!tablesContainer) {
            return;
        }
        var popup = this.getDomRef();
        var container = this.getDomRef('.sasTooltipContainer');
        constraint = constraint || document.documentElement;
        var tables = this.getDomRefs('table');
        for (var i = 0, len = tables.length; i < len; ++i) {
            tables[i].style.display = '';
        }
        this.getDomRef('.sasTipFooter').style.display = 'none';
        // IE does not support multiple arguments for remove.
        tablesContainer.classList.remove('sasTooltipTableLong');
        tablesContainer.classList.remove('sasTooltipTableExtraLong');
        tablesContainer.style.tableLayout = '';
        tablesContainer.style.width = '';
        var contentBounds = constraint.getBoundingClientRect();
        var labels = tablesContainer.querySelectorAll('td.sasTipLabel');
        var values = tablesContainer.querySelectorAll('td.sasTipValue');
        var hasLabelsAndValues = values.length && labels.length;
        var labelLargestWidth = 0;
        var valueLargestWidth = 0;
        popup.style.maxWidth = "".concat(contentBounds.width, "px");
        popup.style.maxHeight = "".concat(contentBounds.height, "px");
        // adjust for clientWidth and scrollWidth not being sub-pixel values
        //  and results in rounding errors in some browsers.
        if (container.clientWidth + 1 < container.scrollWidth) {
            if (hasLabelsAndValues) {
                for (var i = 0, len = labels.length; i < len; ++i) {
                    var labelBounds = labels[i].getBoundingClientRect();
                    labelLargestWidth = Math.max(labelLargestWidth, labelBounds.width);
                    if (values[i]) {
                        var valueBounds = values[i].getBoundingClientRect();
                        valueLargestWidth = Math.max(valueLargestWidth, valueBounds.width);
                    }
                }
            }
            tablesContainer.classList.add('sasTooltipTableLong');
        }
        //Still off?
        if (container.clientWidth + 1 < container.scrollWidth) {
            if (hasLabelsAndValues) {
                var maxItemWidth = container.getBoundingClientRect().width / 2;
                if (labelLargestWidth > maxItemWidth && valueLargestWidth > maxItemWidth) {
                    labels[0].style.width = '50%';
                    values[0].style.width = '50%';
                }
                else if (valueLargestWidth > maxItemWidth) {
                    labels[0].style.width = "".concat(labelLargestWidth, "px");
                }
                else {
                    //if(labelLargestWidth > maxItemWidth)
                    values[0].style.width = "".concat(valueLargestWidth, "px");
                }
            }
            else {
                tablesContainer.classList.remove('sasTooltipTableLong');
                tablesContainer.classList.add('sasTooltipTableExtraLong');
            }
        }
    };
    /**
     * Fit tooltip content to the given space.
     * @protected
     */
    Tooltip.prototype._sizeContent = function () {
        // Only render visible tips.
        var label;
        var popupContainerHeight = parseFloat(getComputedStyle(this.getDomRef('.sasTooltipContainer')).height) + 1;
        var totalHeight = 0;
        var tables = this.getDomRefs('table');
        if (!tables.length) {
            return;
        }
        var footer = this.getDomRef('.sasTipFooter');
        var footerVisible = footer.style.display === '';
        // If we know we are going to overflow tips, then display footer for text height meaurements.
        if (!footerVisible && this._tooltipData.length > tables.length) {
            footer.innerText = 'placeholder';
            footerVisible = true;
            footer.style.display = '';
        }
        if (footerVisible) {
            totalHeight += footer.clientHeight;
        }
        var footerSet = false;
        var longestLabel = 0;
        var lastVisibleIndex = 0;
        for (var i = 0, len = tables.length; i < len; ++i) {
            var table = tables[i];
            if (totalHeight <= popupContainerHeight) {
                totalHeight += table.clientHeight;
            }
            // always display at least one value.
            if (i && (totalHeight > popupContainerHeight || table.style.display === 'none')) {
                if (!footerSet) {
                    footerSet = true;
                    if (footer) {
                        footer.innerText = _createString(this._tipNumberDisplayedString, [
                            i,
                            this._tooltipData.length,
                        ]);
                        footer.style.display = '';
                    }
                    if (!footerVisible) {
                        this._sizeContent();
                        return;
                    }
                }
                table.style.display = 'none';
            }
            else {
                label = table.querySelector('td.sasTipLabel');
                if (label) {
                    longestLabel = Math.max(longestLabel, label.clientWidth);
                }
                table.style.display = '';
                lastVisibleIndex = i;
            }
        }
        if (footerVisible && !footerSet) {
            var dataLength = this._tooltipData.length;
            footer.innerText = _createString(this._tipNumberDisplayedString, [tables.length, dataLength]);
            ltjsUtil.warn("More tips could have been displayed. Total tips: ".concat(dataLength));
        }
        // make sure all of the labels have an equal size.
        for (var i = 0, len = lastVisibleIndex + 1; i < len; ++i) {
            label = tables[i].querySelector('td.sasTipLabel');
            if (label) {
                label.style.width = String(longestLabel) + 'px';
            }
        }
    };
    /**
     * Render the tooltip table based off of the provided tooltip values.
     * @returns {HTMLElement}
     * @protected
     */
    Tooltip.prototype._getPopoverContent = function () {
        var _a;
        var content = this.getDomRef('.sasPopoverContent');
        if (content) {
            content.innerHTML = '';
        }
        if (!this._tooltipData) {
            return null;
        }
        var tablesContainer = document.createElement('div');
        tablesContainer.classList.add('sasTableContainer');
        for (var i = 0, len = Math.min(MAX_DATA_VALUES, this._naiveLength, this._tooltipData.length); i < len; ++i) {
            var item = this._tooltipData[i];
            var table = document.createElement('table');
            table.classList.add('sasTipTable');
            tablesContainer.appendChild(table);
            var tbody = document.createElement('tbody');
            table.appendChild(tbody);
            for (var j = 0, len2 = item.length; j < len2; ++j) {
                var tip = item[j];
                var tr = document.createElement('tr');
                var swatchDom = document.createElement('td');
                // always add the <td> so that the table aligns correctly
                tr.appendChild(swatchDom);
                if (tip.swatchSVG) {
                    swatchDom.innerHTML = tip.swatchSVG;
                    (_a = swatchDom.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList.add('sasTipSwatch');
                }
                if (tip.label) {
                    var labelDom = document.createElement('td');
                    labelDom.innerText = tip.value ? _createString(this._tipColonString, [tip.label]) : tip.label;
                    labelDom.classList.add('sasTipLabel');
                    tr.appendChild(labelDom);
                }
                if (tip.value) {
                    var valueDom = document.createElement('td');
                    valueDom.innerText = tip.value;
                    valueDom.classList.add('sasTipValue');
                    tr.appendChild(valueDom);
                }
                tbody.appendChild(tr);
            }
        }
        var footer = document.createElement('div');
        footer.classList.add('sasTipFooter');
        footer.style.display = 'none';
        var container = document.createElement('div');
        container.classList.add('sasTooltipContainer');
        container.appendChild(tablesContainer);
        container.appendChild(footer);
        return container;
    };
    /**
     * The data set for the tooltip.
     * @param {Array.<Array.<Object>>} data An array of label value pairs. Each object in the array must have a label
     *     property, a value property or both.
     *     Example:
     *         [
     *             [{
     *                 label: string,
     *                 value: string
     *             }]
     *         ]
     */
    Tooltip.prototype.setTooltipValues = function (data, naiveLength) {
        this._tooltipData = data;
        this._naiveLength = naiveLength ? naiveLength : Number.MAX_VALUE;
        var content = this.getDomRef('.sasPopoverContent');
        if (content) {
            content.appendChild(this._getPopoverContent());
        }
    };
    Tooltip.prototype.getTooltipValues = function () {
        return this._tooltipValues;
    };
    Tooltip.prototype.setCssStyleVariables = function () {
        var container = this.getDomRef();
        var styleOverrides = this.getStyleOverrides();
        if (styleOverrides && container) {
            _setCSSStyleVariable(container, '--custom-tip-bg-color', styleOverrides['background-color']);
            _setCSSStyleVariable(container, '--custom-tip-text-color', styleOverrides['color']);
            _setCSSStyleVariable(container, '--custom-tip-font-size', styleOverrides['font-size']);
            _setCSSStyleVariable(container, '--custom-tip-font-family', styleOverrides['font-family']);
            _setCSSStyleVariable(container, '--custom-tip-font-weight', styleOverrides['font-weight']);
        }
    };
    Tooltip.prototype.removeCssStyleVariables = function () {
        var container = this.getDomRef();
        if (container) {
            container.style.removeProperty('--custom-tip-bg-color');
            container.style.removeProperty('--custom-tip-text-color');
            container.style.removeProperty('--custom-tip-font-size');
            container.style.removeProperty('--custom-tip-font-family');
            container.style.removeProperty('--custom-tip-font-weight');
        }
    };
    return Tooltip;
}(Popover));
export default Tooltip;
